import { UserLogActionTypes } from "./types"
import type { UserLogState, UserLogAction } from "./types"
import { commonHelpers } from "@/utils/helpers"

export const initialState: UserLogState = {
  userLogs: [],
  userLogsCount: 0,
  userLogsError: "",
  userLogsLoading: false,
}

const reducer = (state = initialState, action: UserLogAction) => {
  switch (action.type) {
    case UserLogActionTypes.FETCH_REQUESTED: {
      const { scope } = action.payload

      return {
        ...state,
        [`${scope}Loading`]: true,
        [`${scope}Error`]: "",
      }
    }
    case UserLogActionTypes.FETCH_SUCCEEDED: {
      const { scope, data, count } = action.payload

      return {
        ...state,
        [scope]: data,
        [`${scope}Loading`]: false,
        [`${scope}Error`]: "",
        ...(commonHelpers.isNumber(count)
          ? {
              [`${scope}Count`]: count,
            }
          : {}),
      }
    }

    case UserLogActionTypes.FETCH_FAILED: {
      const { scope, error } = action.payload

      return {
        ...state,
        [`${scope}Error`]: error,
      }
    }
    default: {
      return state
    }
  }
}

export default reducer
